var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import { minsToHours } from '../utils';
import { defaultColors } from '@hn-ui/themes';
import { useFetchStudentActivityStream, } from '../shared/hooks/useFetchStudentActivityStream';
import pluralize from 'pluralize';
var useAdoptedStudentActivityStream = function () {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    var url = params[0], query = params[1], fetchProps = params[2];
    return useFetchStudentActivityStream(url, query, __assign(__assign({}, fetchProps), { adapter: adaptStudentActivityStreamToClient }));
};
var adaptStudentActivityStreamToClient = function (data) {
    var output = data.map(function (d) {
        var activeStruggleCards = [];
        var _a = parseStudentGroupData(d), title = _a.title, summary = _a.summary, seenSummary = _a.seenSummary;
        var cards = d.cards.map(function (c) { return ({
            id: c.cardId,
            sessionId: c.sessionId,
            link: c.cardLink,
            accuracy: c.accuracy,
            prefix: c.cardNamePrefix,
            timeSpent: c.timeSpent,
            title: c.cardName,
            struggle: c.struggle,
            status: c.completed ? 'completed' : 'progress',
            date: format(parseISO(c.date), 'MMM dd'),
            exerciseFinished: c.exerciseFinished,
            exerciseFinishedSucc: c.exerciseFinishedSucc,
        }); });
        var deletedCards = d.deletedCards && {
            accuracy: d.deletedCards.accuracy,
            cardsCount: d.deletedCards.cardsCount,
            exerciseFinished: d.deletedCards.exerciseFinished,
            exerciseFinishedSucc: d.deletedCards.exerciseFinishedSucc,
            timeSpent: d.deletedCards.timeSpent,
        };
        cards.forEach(function (card) {
            if (card.struggle && !d.seenNotifications.includes(card.sessionId))
                activeStruggleCards.push(card.sessionId);
        });
        return {
            title: title,
            summary: summary,
            seenSummary: seenSummary,
            cards: cards,
            activeStruggleCards: activeStruggleCards,
            deletedCards: deletedCards,
        };
    });
    return output;
};
var parseStudentGroupData = function (group) {
    var title = '';
    var summary = '';
    var seenSummary = '';
    var _a = minsToHours(group.timeSpent), mins = _a.mins, hours = _a.hours;
    var hoursText = hours ? " " + hours + " h" : '';
    var minsText = '';
    if (mins)
        minsText = " " + mins + " min";
    else
        minsText = hours ? '' : ' < 1 min';
    var isAllSeen = group.seenNotifications.length === group.struggleTasks;
    var struggleCount = isAllSeen
        ? group.struggleTasks
        : group.struggleTasks - group.seenNotifications.length;
    var struggleColor = isAllSeen ? '#777B8B' : defaultColors.red50;
    var struggle = group.struggleTasks
        ? " <span style='color: " + struggleColor + ";'>(" + struggleCount + " struggle " + pluralize('task', struggleCount) + ")</span>"
        : '';
    title = group.title;
    summary = pluralize('task', group.tasksCompleted, true) + " solved" + struggle + " | time spent:" + hoursText + minsText + " | avg. accuracy " + group.avgAccuracy + "%";
    if (!isAllSeen && group.struggleTasks) {
        var seenStruggle = " <span style='color:#777B8B;'>(" + group.struggleTasks + " struggle " + pluralize('task', group.struggleTasks) + ")</span>";
        seenSummary = pluralize('task', group.tasksCompleted, true) + " solved" + seenStruggle + " | time spent:" + hoursText + minsText + " | avg. accuracy " + group.avgAccuracy + "%";
    }
    else
        seenSummary = summary;
    return { title: title, summary: summary, seenSummary: seenSummary };
};
export { useAdoptedStudentActivityStream };
